<template>
    <div class="container">
        <div class="footlin10"></div>
        <div class="ftext10">
            <div class="w-1300 flex jc-b">
                <div class="flex pt40 fff" style="line-height: 40px;" @mousemove="mouseLeaveHandler">
                    <div class="pt10"> <img src="../assets/home/footicon.png" /></div>
                    <div class="pt10">
                        <div>Copyright @2014 &nbsp;&nbsp;&nbsp; 宁波市教育考试院&nbsp;&nbsp;&nbsp;
                            浙ICP备05008988-1&nbsp;&nbsp;&nbsp;<img src="../assets/home/image 7.png" alt=""> 浙公网安备:
                            33021202001241号</div>
                        <div style="text-align: left;">地址: 浙江省宁波市开明街89号 咨询电话: 0574-87323004 邮编: 315010</div>
                    </div>
                </div>
                <div class="footsel ml30 pt70">
                    <div class="fff pb20" style="text-align: left; margin-left: 8px;">友情链接：</div>
                    <div style="display: flex;justify-content: center; padding-left: 10px;">
                        <el-popover placement="top-start" :width="200" trigger="hover" :teleported="false">
                            <div  v-for="item in options1" >
                                
                               <div class="listpop" @click="opfun1(item.value)">{{ item.label }}</div> 
                            
                            </div>
                            <template #reference>
                                <div class="tooplist">
                                    <div style="height: 24px;line-height: 24px;">市内教育网络资源</div>
                                    <img src="../assets/svg/jt10.svg" style="width: 24px;height: 24px;" />
                                </div>
                            </template>
                        </el-popover>
                        <el-popover placement="top-start" :width="200" trigger="hover" :teleported="false">
                            <div class="listpop" v-for="item in options2" >
                               <div @click="opfun1(item.value)">{{ item.label }}</div> 
                            </div>
                            <template #reference>
                                <div class="tooplist">
                                    <div style="height: 24px;line-height: 24px; margin-left: 36px;">省内教育网络资源</div>
                                    <img src="../assets/svg/jt10.svg" style="width: 24px;height: 24px;" />
                                </div>
                            </template>
                        </el-popover>
                        <el-popover placement="top-start" :width="200" trigger="hover" :teleported="false">
                            <div class="listpop" v-for="item in options3" @click="opfun1(item.value)">{{ item.label }}</div>
                            <template #reference>
                                <div class="tooplist">
                                    <div style="height: 24px;line-height: 24px; margin-left: 36px;">全国教育网络资源</div>
                                    <img src="../assets/svg/jt10.svg" style="width: 24px;height: 24px;" />
                                </div>
                            </template>
                        </el-popover>
                        <!-- <el-select ref="selectRef" @mouseenter="overfun1" v-model="value" :teleported="false"
                            style="width: 96px; font-size: 12px;" placeholder="市内教育网络资源" size="small" @change="opfun1">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <el-select ref="selectRef2" @mouseenter="overfun2" v-model="value" class="fsel ml10"
                            :teleported="false" style="width: 96px; font-size: 12px;" placeholder="省内教育网络资源" size="small"
                            @change="opfun2">
                            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <el-select ref="selectRef3" @mouseenter="overfun3" v-model="value" class="fsel ml10"
                            :teleported="false" style="width: 96px; font-size: 12px;" placeholder="全国教育网络资源" size="small"
                            @change="opfun3">
                            <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted } from 'vue'
let list = ref([])
onBeforeMount(() => { listup() })
onMounted(() => { console.log('3.-组件挂载到页面之后执行-------onMounted') })

const opfun1 = (t) => {
    window.open(t)
}

const opfun2 = (t) => {
    window.open(t)
}
const opfun3 = (t) => {
    window.open(t)
}


const listup = () => { }
const options1 = ref([
    {
        value: 'http://jyj.ningbo.gov.cn/',
        label: '宁波市教育局',
    },
    {
        value: 'http://www.nbjys.cn/Site_nbjys/TopPage.aspx',
        label: '宁波基础教学研究',
    },
    {
        value: 'http://www.nbzcj.net/',
        label: '宁波职成教教研室',
    },
    {
        value: 'http://jyj.ningbo.gov.cn/col/col1229513840/index.html',
        label: '宁波市教育工会',
    },
    {
        value: 'http://www.nbzcj.net/?websiteId=159500&webEnc=211a3e8d4a142732e1eb74e12c3bf9b5a2a4b6fb786c3784ca9ab4019e327434&pageId=271207&wfwfid=194418',
        label: '宁波成人教育信息网',
    },
    {
        value: 'https://nlic.cn/',
        label: '宁波大学园区图书馆',
    },
    {
        value: 'https://teacher.nbu.edu.cn/',
        label: '宁波教育督导网',
    },
])
const options2 = ref([
    {
        value: 'https://www.zjzs.net/moban/index/index.html',
        label: '浙江教育考试院',
    },
    {
        value: 'https://edu.hangzhou.gov.cn/',
        label: '杭州教育网',
    },
    {
        value: 'http://jyj.qz.gov.cn/',
        label: '衢州教育网',
    },
    {
        value: 'https://edu.wenzhou.gov.cn/col/col1330306/',
        label: '温州教育网',
    },
    {
        value: 'https://huedu.huzhou.gov.cn/',
        label: '湖州教育网',
    },
    {
        value: 'http://jxksy.zjjxedu.gov.cn/',
        label: '嘉兴教育考试院',
    },
    {
        value: 'http://www.sxszsks.cn/',
        label: '绍兴教育网',
    },
    {
        value: 'http://zsjy.zhoushan.gov.cn/',
        label: '舟山教育网',
    },
    {
        value: 'http://jyj.jinhua.gov.cn/col/col1229072237/index.html',
        label: '金华教育网',
    },
    {
        value: 'http://jyj.lishui.gov.cn/',
        label: '丽水教育网',
    },
    {
        value: 'http://jyj.zjtz.gov.cn/',
        label: '台州教育网',
    },
])

const options3 = ref([
    {
        value: 'http://www.moe.gov.cn/',
        label: '中国教育部',
    },
    {
        value: 'https://www.edu.cn/',
        label: '中国教育科研网',
    },
    {
        value: 'https://www.nlc.cn/web/index.shtml',
        label: '中国国家图书馆',
    },
    {
        value: 'https://www.chsi.com.cn/',
        label: '高等教育学生信息网',
    },
    {
        value: 'https://www.neea.edu.cn/',
        label: '中国教育考试网',
    },
    {
        value: 'https://www.chinadegrees.cn/',
        label: '中国学位与研究生教育网',
    },
    {
        value: 'https://www.cscse.edu.cn/',
        label: '中国留学网',
    },
    {
        value: 'https://www.gqt.org.cn/',
        label: '中国共青团网',
    },
    {
        value: 'https://www.youth.cn/',
        label: '中国青年网',
    },
    {
        value: 'https://www.eduyun.cn/',
        label: '国家教育资源公共服务平台',
    },
])
</script>

<style lang="less" scoped>
.tooplist{
    display: flex; justify-content: center;font-size: 12px;color: #fff;
}
.listpop{
    width: 100%;
    height: 25px;
    font-size: 12px;
    cursor: pointer;
    padding-top: 6px;
}
.hrefcar {
    width: 150px;
    height: 180px;
    background-color: #fff;
    position: absolute;
    z-index: 99;
    bottom: 40px;
    left: 80px;
    line-height: 26px;
    box-shadow: 5px 5px 2px 0px rgb(126, 123, 123);
    border-radius: 10px
}

:deep(.el-input__wrapper) {
    background: linear-gradient(90deg, #0b3571, rgba(11, 53, 113, 0) 100%);
    box-shadow: 0 0 0 0 var(--el-input-border-color, var(--el-border-color)) inset;
}

:deep(.el-select:hover:not(.el-select--disabled) .el-input__wrapper) {
    // background: #1967BC;
    box-shadow: 0 0 0 0 var(--el-input-border-color, var(--el-border-color)) inset;

}

/deep/ .el-select .el-input.is-focus .el-input__wrapper {
    box-shadow: 0 0 0 0 var(--el-input-border-color, var(--el-border-color)) inset !important;

}

:deep(.el-select .el-input__wrapper) {
    background: #950606;
}

:deep(.el-input__inner) {
    &::placeholder {
        color: #fff;
    }
}
</style>
 
<style lang="less">
.el-select:hover {
    border: none !important;
}

.footlin10 {
    width: 100%;
    height: 10px;
    background: #BB0606;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.ftext10 {
    width: 100%;
    height: 156px;
    background: #950606;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}
</style>
